const common = {
  "nav.home": "首页",
  "nav.category": "分类",
  "nav.about": "关于我们",
  "nav.search": "搜索影视内容...",
  "footer.about": "关于西瓜视频",
  "footer.aboutDesc": "西瓜视频汇聚最新电影、热播电视剧和高分综艺，全部内容免费在线观看。高清画质流畅不卡顿，随时随地享受追剧乐趣。",
  "footer.quickLinks": "快速链接",
  "footer.categories": "热门分类",
  "footer.contact": "联系我们",
  "footer.copyright": "© 2026 西瓜视频 版权所有",
  "hero.title": "精彩视界，尽在西瓜",
  "hero.subtitle": "最新电影 · 热播电视剧 · 高分综艺",
  "hero.description": "超清画质流畅不卡顿，无需下载，打开即看",
  "hero.cta": "开始观看",
  "hero.browse": "浏览分类",
  "section.featured": "热门推荐",
  "section.featuredDesc": "本周最受欢迎的影视内容，大家都在看",
  "section.categories": "内容分类",
  "section.categoriesDesc": "按类型浏览您感兴趣的内容",
  "section.latest": "最新上线",
  "section.latestDesc": "刚刚更新的热门内容，抢先观看",
  "section.faq": "常见问题",
  "section.faqDesc": "关于西瓜视频，您想了解的都在这里",
  "rating": "评分",
  "episodes": "集数",
  "views": "次播放",
  "watchNow": "立即观看",
  "learnMore": "了解更多",
  "viewAll": "查看全部",
  "noContent": "暂无内容",
  "breadcrumb.home": "首页",
  "breadcrumb.category": "分类",
  "breadcrumb.about": "关于我们",
  "breadcrumb.article": "内容详情",
  "scrollTop": "回到顶部",
};

export default common;